var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlreadyRegistered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.87 19.6584L33.3158 19.652M38.0045 35.6318V41.7201C38.0045 42.6439 37.2343 43.3943 36.2848 43.3943L13.7092 43.4066C12.7597 43.4066 11.9885 42.6583 11.9885 41.7345L11.9727 13.6592C11.9727 12.7354 12.7418 11.985 13.6913 11.985L36.0801 11.9727C37.0296 11.9727 37.8009 12.721 37.8009 13.6449V22.1003M16.064 19.4016L17.6202 21.1723L20.0721 17.9798M22.8743 27.6651L31.151 27.6609M16.0693 27.4094L17.6255 29.1791L20.0774 25.9867M22.8784 35.6729L26.4866 35.6708M16.0735 35.4162L17.6296 37.187L20.0815 33.9945M32.3311 34.4954L34.0382 36.0188L44.1317 25.2947L41.416 22.8701C41.1607 22.6412 40.7629 22.6587 40.5287 22.9071L30.8604 33.1804L29.3982 37.074C29.222 37.5432 29.7168 37.9846 30.1821 37.7731L34.0393 36.0177M43.9704 25.1469L44.7712 25.8614C45.3409 26.3695 45.3789 27.2308 44.8566 27.7851L41.2453 31.6181M42.6568 21.6732L43.4449 20.8376C43.6749 20.5933 44.0642 20.5769 44.3153 20.8007L45.5381 21.8908C45.7892 22.1146 45.806 22.4934 45.576 22.7377L44.7879 23.5733",
    stroke: "#878686",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlreadyRegistered);
export default __webpack_public_path__ + "static/media/already-registered.e9de18fd9cbe111bb50bb12fc1a1ea6a.svg";
export { ForwardRef as ReactComponent };